<template>
    <div>

        <div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">
            <h5>Update Pickup Party</h5>
            <p style="margin-bottom: 15px">Order No.: {{order.orderNumber}}</p>

            <Form :model="pickupPartyForm" :rules="ruleValidatePickup" label-position="top"  ref="pickupPartyForm">
                <Row :gutter="10">
                    <Col span="24">
                        <FormItem prop="pickupPartyName">
                            <ApolloQuery :query="query_SEARCH_PICKUPPARTY" :debounce="500" :skip="skip.pickupPartySkip"
                                         :variables="{pickupPartyFilter:pickupPartyFilter, filterpickupPartyCity:[]}">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="Pickup Party" @on-search="onSearchPickupParty($event)"
                                                      v-model="pickupPartyForm.pickupPartyName">
                                            <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                    v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                <div class="ivu-select-item-div" @click="assignPickupParty(companyObj)">{{companyObj.name}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                    <Col span="24" style="margin: 0 0 -20px 0">
                        <FormItem  prop="add1">
                            <Input placeholder="Address 1" v-model="pickupPartyForm.add1"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24" style="margin: 0 0 -20px 0">
                        <FormItem  prop="add2">
                            <Input placeholder="Address 2" v-model="pickupPartyForm.add2"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem prop="area">
                            <Input placeholder="Area" v-model="pickupPartyForm.area"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem  prop="pincode">
                            <Input number placeholder="PIN" v-model="pickupPartyForm.pincode"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem  prop="city" >
                            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                                         :debounce="500" :skip="skip.citySkip">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="City" v-model="pickupPartyForm.city"
                                                      @on-search="onSearchCity">
                                            <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem prop="state" >
                            <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                                         :debounce="500" :skip="skip.stateSkip">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="State" v-model="pickupPartyForm.state"
                                                      @on-search="onSearchState">
                                            <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                                <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
                <div style="float: right">
                    <Button @click="checkPickupForm" :loading="loader1">
                        <span v-if="!loader1">Update</span>
                        <span v-else>Loading...</span>
                    </Button>
                    <Button style="margin-left: 10px" @click="close()">Cancel</Button>
                </div>
        </div>

        <!-- <div v-if="isRenderer" style="text-align: center" :class="cellProperties.readOnly?'cell-readonly':''">
            {{value}} <br> <span>( {{pickupAreaGroup}} )</span>
        </div> -->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import ValidationRules from '../../Constants/ValidationRules'
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"
    import {SEARCH_PICKUPPARTY} from '../../graphql/queries/companies'
    import { SEARCH_CITY, SEARCH_STATE } from '../../graphql/queries/territories'
    import moment from 'moment'
    import {CREATE_UPDATE_ORDER_COMPANY} from "../../graphql/mutations/companies";

    export default {
        name: "PickupPartyPopup",
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                revertOrderIn: [Constants.internalStatus.underPickupProcess,Constants.internalStatus.readyForPickup,Constants.internalStatus.tempoOnTheWayToPickupLoad,
                                Constants.internalStatus.tempoWaitingForLoadingMaterial],
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                query_SEARCH_PICKUPPARTY: SEARCH_PICKUPPARTY,
                query_SEARCH_CITY: SEARCH_CITY,
                query_SEARCH_STATE: SEARCH_STATE,
                pickupPartyForm:{
                    pickupPartyName: '',
                    pickupPartyId: '',
                    mobile: '',
                    email: '',
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: '',
                    state: '',
                    city: ''
                },
                ruleValidatePickup: {pickupPartyName: ValidationRules.textField('Pickup Party Name')},
                pickupPartyFilter: '%%',
                cityFilter: '%%',
                stateFilter: '%%',
                skip: {pickupPartySkip: true, dropPartySkip: true, citySkip: true, stateSkip: true},
                pickupAreaGroup: '',
                dropAreaGroup: '',
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();
                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                let screen = this.$parent.$parent.$parent.screen
                let ordersVariable = screen + '_orders'
                let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
                this.order = this.$parent.$parent.$parent[ordersVariable][pRow]

                if(!this.order.orderDetails.pickupPoint.pickupPartyId){
                    this.onEditPickupOfOrder(this.order)
                }else{
                    this.onEditPickupOfOrderDetail(this.order.orderDetails)
                }

                this.isVisible = true
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            onSearchPickupParty: function(val){
                this.pickupPartyFilter = '%' + val + '%';
                this.skip.pickupPartySkip = false;
            },
            assignPickupParty(companyObj){
                this.pickupPartyForm.pickupPartyId = companyObj.id;
                this.pickupPartyForm.mobile = companyObj.mobile;
                this.pickupPartyForm.email = companyObj.email;
            },
            onSearchCity: function(val){
                this.cityFilter = '%' + val + '%';
                this.skip.citySkip = false;
            },
            onSearchState: function(val){
                this.stateFilter = '%' + val + '%';
                this.skip.stateSkip = false;
            },
            onEditPickupOfOrder(order){
                this.pickupPartyForm.pickupPartyName = order.pickuppartyobject.name;
                this.pickupPartyForm.pickupPartyId = order.pickuppartyobject.id;
                this.pickupPartyForm.mobile = order.pickuppartyobject.mobile;
                this.pickupPartyForm.email = order.pickuppartyobject.email;
                this.pickupPartyForm.add1 = order.pickuppartyobject.address[0].add1;
                this.pickupPartyForm.add2 = order.pickuppartyobject.address[0].add2;
                this.pickupPartyForm.area = order.pickuppartyobject.address[0].area;
                this.pickupPartyForm.pincode = order.pickuppartyobject.address[0].pincode;
                this.pickupPartyForm.state = order.pickuppartyobject.address[0].state;
                this.pickupPartyForm.city = order.pickuppartyobject.address[0].city;
            },
            onEditPickupOfOrderDetail(orderDetails){
                this.pickupPartyForm.pickupPartyName = orderDetails.pickupPoint.pickupPartyName;
                this.pickupPartyForm.pickupPartyId = orderDetails.pickupPoint.pickupPartyId;
                this.pickupPartyForm.mobile = orderDetails.pickupPoint.mobile
                this.pickupPartyForm.email = orderDetails.pickupPoint.email
                this.pickupPartyForm.add1 = orderDetails.pickupPoint.add1;
                this.pickupPartyForm.add2 = orderDetails.pickupPoint.add2;
                this.pickupPartyForm.area = orderDetails.pickupPoint.area;
                this.pickupPartyForm.pincode = orderDetails.pickupPoint.pincode;
                this.pickupPartyForm.state = orderDetails.pickupPoint.state;
                this.pickupPartyForm.city = orderDetails.pickupPoint.city;
            },
            checkPickupForm(){
                this.$refs['pickupPartyForm'].validate((valid) => {
                    if (valid) {
                      let mappedAreas = this.$store.state.mappedAreas
                      let obj = {pickupPoint: this.pickupPartyForm, pickupAreaGroup: mappedAreas[this.pickupPartyForm.area.toLowerCase()] || null}
                        this.updateRecord(this.order.orderDetails.id, obj, 'orderDetails', 'loader1')
                    /* --------- Revert Order stage to 'Order Not Ready' based on current stage ------- */
                      if(this.revertOrderIn.includes(this.order.internalstatus)) {
                        obj = {internalstatus: Constants.internalStatus.orderNotReady, lastStageUpdatedOn: moment().format(),
                               lastStageUpdatedBy: this.userObj.user.id}
                        this.updateRecord(this.order.id, obj, 'orders', 'loader1')
                      }
                    /* ----------x------------------x-------------------x---------------------x--------- */
                      this.saveOrderCompany()                                     //Saved in separate table
                    }
                })
            },
            async saveOrderCompany(){
                let response = await this.$apollo.mutate({
                  mutation: CREATE_UPDATE_ORDER_COMPANY,
                  variables: {
                    orderCompany: {
                      name: this.pickupPartyForm.pickupPartyName,
                      mobile: this.pickupPartyForm.mobile,
                      email: this.pickupPartyForm.email,
                      addressLine1: this.pickupPartyForm.add1,
                      addressLine2: this.pickupPartyForm.add2,
                      area: this.pickupPartyForm.area,
                      city: this.pickupPartyForm.city,
                      state: this.pickupPartyForm.state,
                      pincode: this.pickupPartyForm.pincode,
                      originalCompanyId: this.pickupPartyForm.pickupPartyId,
                      type: 'PICKUP',
                      orderId: this.order.id
                    },
                    updateColumns: ['name', 'mobile', 'email', 'addressLine1', 'addressLine2', 'area', 'city', 'state', 'pincode', 'originalCompanyId']
                  }
                })
              if(response.data) this.$Message.success('Order Company saved successfully!')
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.finishEditing()
                }
            },
        },
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
</style>
